import {
  ResponsesTableRow,
  useResponseDownload,
} from "../../../hooks/api/responses";
import { AnyObject } from "../../../store/auth";
import { downloadFromAnchor } from "../../../utils";
import { listAction } from "../../Common/Table";

export default function DownloadButton({
  record,
}: { record: ResponsesTableRow } & AnyObject) {
  const responseDownload = useResponseDownload();
  const ActionButton = listAction.download;

  return (
    <>
      <ActionButton
        loading={responseDownload.loading}
        title="Download response"
        onClick={(e: React.MouseEvent) => {
          e.stopPropagation();
          responseDownload
            .fetch(undefined, `${record.job?.id}/survey-response/pdf`)
            .then((response) => {
              if (!response) return;

              downloadFromAnchor(
                response,
                `${record.title}-${record.jobId}`,
                "application/pdf",
              );
            });
        }}
      />
    </>
  );
}
